import { render, staticRenderFns } from "./SearchTransfer.vue?vue&type=template&id=70b91478&scoped=true&"
import script from "./SearchTransfer.vue?vue&type=script&lang=ts&"
export * from "./SearchTransfer.vue?vue&type=script&lang=ts&"
import style0 from "./SearchTransfer.vue?vue&type=style&index=0&id=70b91478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b91478",
  null
  
)

export default component.exports